import cn from 'classnames';
import styles from "./ImpersonateWarning.module.scss";
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { Typography } from 'seagull';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function ImpersonateWarning() {
  const fakeIdentity = useStore(selectors.impersonatingAs);
  const realIdentity = useStore(state => {
    var _state$claims;
    return (_state$claims = state.claims) === null || _state$claims === void 0 ? void 0 : _state$claims.email;
  });
  return fakeIdentity && realIdentity ? /*#__PURE__*/_jsx("div", {
    className: cn(styles.root, 'hide-on-print'),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsxs(Typography, {
        variant: "h6",
        ellipsis: true,
        children: [realIdentity, " impersonating as ", fakeIdentity, " - you cannot change anything"]
      })
    })
  }) : null;
}